<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import useCdcProps from '@/composables/useCdcProps'

const { t } = useI18n()

const { xprops } = useCdcProps()
const handleResetMboModule = xprops.handleResetMboModule

const resetInProgress = ref(false)

const resetMboModule = async () => {
  try {
    resetInProgress.value = true
    await handleResetMboModule()
  } catch (error) {
    throw {
      message: 'Shop reset failed',
      response: {
        status: 'shop_reset_failed',
      },
    }
  }
}
</script>

<template>
  <div class="flex flex-col items-center justify-center mb-4 sm:mb-8 max-w-2xl">
    <template v-if="resetInProgress">
      <UiSpinner :label="t('error_screen.401.loading')" />
    </template>

    <template v-else>
      <h1 class="text-2xl font-bold mb-2 text-center">
        {{ t('error_screen.401.title') }}
      </h1>
      <p class="text-sm text-center">
        {{ t('error_screen.401.description') }}
      </p>
    </template>
  </div>
  <div class="flex gap-4 justify-center">
    <UiButton :disabled="resetInProgress" @click="resetMboModule()">{{
      t('error_screen.401.cta_reload')
    }}</UiButton>
  </div>
</template>
